(() => {
  const mount=document.querySelector('[data-glaam-configured-mount]');
  if(!mount)return;
  const saved=new Map();
  const hadStickyClass=document.body.classList.contains('glaam-has-variant-sticky');
  function hide(el){if(!el)return;if(!saved.has(el))saved.set(el,el.hidden);el.hidden=true;}
  function deactivate(){
    document.querySelector('.glaam-variant-modal button[data-close]')?.click();
    document.querySelector('.glaam-builder__gallery button[data-gallery-close]')?.click();
    mount.hidden=true;
    if(mount.parentElement!==document.body)document.body.append(mount);
    for(const [el,hidden] of saved)el.hidden=hidden;
    saved.clear();
    document.body.classList.remove('glaam-configured-active','glaam-has-variant-sticky');
    document.body.classList.add('glaam-configured-hidden');
  }
  function visible(el){
    for(let node=el;node&&node!==document.body;node=node.parentElement){if(node.hidden||getComputedStyle(node).display==='none')return false;}
    return Boolean(el);
  }
  function activate(){
    const info=document.querySelector('product-info');
    const position=info?.querySelector('[data-glaam-pack-position]');
    if(!info||!position||!visible(position)){deactivate();return;}
    const picker=mount.querySelector('.glaam-variant-picker');
    if(!picker||picker.dataset.initialized!=='true')return;
    const existing=info.querySelector('#glaam-variant-demo');
    if(existing&&!mount.contains(existing))return;
    if(mount.parentElement!==position)position.append(mount);
    position.querySelector('[data-glaam-pack-editor-notice]')?.setAttribute('hidden','');
    mount.hidden=false;
    hide(info.querySelector('product-form'));hide(info.querySelector('#offre'));
    info.querySelectorAll('variant-selects,variant-radios,.collection-bundle-container').forEach(el=>{if(!mount.contains(el))hide(el);});
    document.body.classList.remove('glaam-configured-hidden');
    document.body.classList.add('glaam-configured-active');
    if(hadStickyClass)document.body.classList.add('glaam-has-variant-sticky');
    window.GlaamFormulaLinks?.();
  }
  document.addEventListener('glaam:ready',activate);
  document.addEventListener('shopify:section:load',activate);
  document.addEventListener('shopify:block:select',activate);
  document.addEventListener('shopify:section:unload',event=>{if(event.target.contains?.(mount)||event.target.querySelector?.('[data-glaam-pack-position]'))deactivate();});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',activate,{once:true});else activate();
})();
